<div class="header" [class.promo-behind]="showPromotion">
  <button class="back-button" (click)="goBack()" aria-label="back">
    <svg class="back-icon" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M7.66602 14.25L1.41602 8L7.66602 1.75" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
  <div>
    <h1>{{ 'orderDetails.header.title' | translate }}</h1>
    <h3 *ngIf="orderingType === 'dine-in' && (tableName || tableId)">{{ 'orderDetails.header.table' | translate }} {{tableName || tableId}}</h3>
  </div>
  <span></span>
</div>
<div class="order-history" [class.promo-behind]="showPromotion">
  <div class="order-history-item" *ngFor="let order of recentOrderHistory" (click)="viewOrderDetails(order.id, false)">
    <div>
      <h4>{{ 'orderDetails.orderHistory.order' | translate }}{{order.id}}</h4>
      <!-- What the venue did with it: kept fresh by refreshRecentStatuses(). -->
      <span class="order-status" *ngIf="orderStatusKey(order) as statusKey" [ngClass]="orderStatusClass(order)">
        {{ statusKey | translate }}
      </span>
      <p>
        {{order.total | number:'1.2-2'}} <span [innerHTML]="currencySymbol"></span>
        <ng-container *ngIf="isSecondCurrencyActive() && getSecondPrice(order.total)">
          <span class="separator">/</span>
          <span class="second-price">{{getSecondPrice(order.total)}} <span [innerHTML]="getSecondCurrencySymbol()"></span></span>
        </ng-container>
      </p>
      <!-- What a code took off this order. Quiet, under the total it explains — the
           figure above is already net. Absent on orders placed without one, and on
           entries stored before promo codes existed. -->
      <p class="order-history-promo" *ngIf="order.discountTotal">
        {{ order.promoCode || ('orderDetails.promoCode.label' | translate) }}
        −{{ order.discountTotal | number:'1.2-2' }} <span [innerHTML]="currencySymbol"></span>
      </p>
    </div>
    <span class="chevron" aria-hidden="true"></span>
  </div>
</div>
<div class="order-details-container" [class.promo-behind]="showPromotion"
     [class.submitting]="isSubmittingOrder">


  <button class="note-button" (click)="toggleNoteModal()">
    <div>
      <h3>{{ 'orderDetails.note.button.title' | translate }}</h3>
      <p>{{ 'orderDetails.note.button.subtitle' | translate }}</p>
    </div>
    <img src="../../../assets/right-arrow.svg" alt="">
  </button>

  <!-- Note Modal -->
  <div class="note-modal" [class.open]="isNoteModalOpen">
    <div class="modal-overlay" (click)="toggleNoteModal()"></div>
    <div class="modal-content" (click)="$event.stopPropagation()">
      <textarea [(ngModel)]="orderNote" [placeholder]="'orderDetails.note.modal.placeholder' | translate"
        rows="2"></textarea>
      <button class="save-button" (click)="saveNote()">{{ 'orderDetails.note.modal.save' | translate }}</button>
    </div>
  </div>

  <!-- Item Note Modal — the order-note sheet above, aimed at one line. `maxlength` counts what the
       counter counts; the cart service normalizes again (trim, control characters, 200 cap) so the
       stored note never depends on the browser having enforced it. -->
  <div class="note-modal item-note-modal" [class.open]="isItemNoteModalOpen">
    <div class="modal-overlay" (click)="closeItemNoteEditor()"></div>
    <div class="modal-content" (click)="$event.stopPropagation()" role="dialog" aria-modal="true"
      aria-labelledby="item-note-modal-title">
      <h3 id="item-note-modal-title" class="item-note-modal-title">
        {{ 'orderDetails.itemNote.title' | translate:{ item: itemNoteLineName } }}
      </h3>
      <textarea [(ngModel)]="itemNoteDraft" [attr.maxlength]="itemNoteMaxLength"
        [placeholder]="'orderDetails.itemNote.placeholder' | translate" rows="2"></textarea>
      <p class="item-note-counter" aria-hidden="true">{{itemNoteDraft.length}}/{{itemNoteMaxLength}}</p>
      <button class="save-button" (click)="saveItemNote()">{{ 'orderDetails.itemNote.save' | translate }}</button>
      <button class="remove-button" *ngIf="itemNoteHadNote" (click)="removeItemNote()">
        {{ 'orderDetails.itemNote.remove' | translate }}
      </button>
    </div>
  </div>

  <!-- The pieces of a cart line, defined once for both surfaces that show one: the live cart below
       and the order-history drawer further down. One definition because a guest comparing a past
       order with the current one is comparing these exact strings, and two spellings of one
       combination read as two different dishes.

       ## Where the quantity control sits

       Inside the text column, on whichever money row is the card's LAST — the base price when the
       line has no add-ons, the line total when it does. That is iOS `OrderItemView`, and it is not
       a cosmetic choice: with the control as a SIBLING of the text block, the column is only what
       is left between the 100px image tile and the stepper — about 118px at a 353px row. A product
       name broke after two or three words and the add-on block had to escape onto a full-width row
       of its own to be legible at all. Moving the control inside lets the column run to the card's
       trailing edge, so the title gets the width it was always competing for and the add-ons sit
       directly under the price they belong to.

       Each add-on still gets its own row rather than being joined into `a · b`. iOS joins because
       its column is ~80pt narrower whenever the line carries an image; `OrderItemView.swift` says
       so itself, and names web's row-per-add-on as the reference behaviour.

       `editable` is a parameter rather than something these blocks work out for themselves: the
       drawer renders SUBMITTED orders through them, and those must stay read-only whatever the live
       cart's ordering state happens to be. -->

  <!-- Rendered at whichever money row is last, so it is written once and placed twice. -->
  <ng-template #quantityStepper let-item="item">
    <div class="quantity-controls">
      <button (click)="updateQuantity(item, -1)" aria-label="minus">
        <svg class="pill-glyph" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M3.42383 9H15.7988" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <span>{{item.quantity}}</span>
      <button (click)="updateQuantity(item, 1)" aria-label="plus">
        <svg class="pill-glyph" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M3.42383 9H15.7988" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9.61133 2.8125V15.1875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </ng-template>

  <ng-template #supplementRows let-item="item" let-editable="editable">
    <!-- A convenience tap target only — no button role, no tab stop, matching iOS, which attaches a
         plain `.onTapGesture` here. Announcing it as a button would read out its raw contents
         ("+ Extra cheese ×2 100 250") as the control's name, and the title above is already the one
         labelled way in. -->
    <div class="item-supplements" *ngIf="hasSupplements(item)" [class.editable]="editable && canEditLine(item)"
      (click)="editable && openLineEditor(item)">
      <span class="supplement-row" *ngFor="let supplement of lineSupplements(item)">
        <span class="supplement-name">{{supplementLabel(supplement)}}</span>
        <!-- A free add-on shows no figure at all: "+ Extra napkin 0 €" reads as a price, not as
             "free", and the guest has nothing to reconcile against the line total. -->
        <span class="supplement-price" *ngIf="supplementRowTotal(supplement) > 0">
          {{supplementRowTotal(supplement) | price}} <span [innerHTML]="currencySymbol"></span>
          <span class="second-price" *ngIf="isSecondCurrencyActive() && getSecondPrice(supplementRowTotal(supplement))"> {{getSecondPrice(supplementRowTotal(supplement))}} <span [innerHTML]="getSecondCurrencySymbol()"></span></span>
        </span>
      </span>
    </div>
  </ng-template>

  <!-- The line's note, directly under the item name on every surface that lists lines. Editable:
       "+ Add note" when empty, the note itself (tap to edit) when set. Read-only: the note or
       nothing. Wraps in full — a guest's "no onion on one" truncated to "no oni…" is a wrong order. -->
  <ng-template #itemNoteRow let-item="item" let-editable="editable">
    <button type="button" class="item-note" *ngIf="editable" (click)="openItemNoteEditor(item)">
      <ng-container *ngIf="itemNote(item); else addItemNote">
        <span class="sr-only">{{ 'orderDetails.itemNote.edit' | translate }}:</span>
        <span class="item-note-text">{{itemNote(item)}}</span>
      </ng-container>
      <ng-template #addItemNote>
        <span class="item-note-add">+ {{ 'orderDetails.itemNote.add' | translate }}</span>
      </ng-template>
    </button>
    <p class="item-note item-note-text" *ngIf="!editable && itemNote(item)">{{itemNote(item)}}</p>
  </ng-template>

  <!-- The one add-on-inclusive figure on the line. The unit price above stays the BASE price, so
       this is the only place the two are ever added together. Shares its row with the quantity
       control, which is what makes it the card's last line. -->
  <ng-template #lineTotalText let-item="item">
    <span class="line-total">
      {{lineTotal(item) | price}} <span [innerHTML]="currencySymbol"></span>
      <span class="second-price" *ngIf="isSecondCurrencyActive() && getSecondPrice(lineTotal(item))"> {{getSecondPrice(lineTotal(item))}} <span [innerHTML]="getSecondCurrencySymbol()"></span></span>
    </span>
  </ng-template>

  <!-- The base unit price, identical on both surfaces. -->
  <ng-template #basePriceText let-item="item">
    <p class="item-price">
      <ng-container *ngIf="!isOnSale(item)">
        {{item.price | price}} <span [innerHTML]="currencySymbol"></span>
        <span class="second-price" *ngIf="isSecondCurrencyActive() && getSecondPrice(item.price)"> {{getSecondPrice(item.price)}} <span [innerHTML]="getSecondCurrencySymbol()"></span></span>
      </ng-container>
      <ng-container *ngIf="isOnSale(item)">
        {{item.price | price}} <span [innerHTML]="currencySymbol"></span>
        <span class="original-price">{{item.regular_price | price}}</span>
        <span class="second-price-pair">
          <span class="second-price" *ngIf="isSecondCurrencyActive() && getSecondPrice(item.price)"> {{getSecondPrice(item.price)}} <span [innerHTML]="getSecondCurrencySymbol()"></span></span>
          <span class="second-price second-regular-price" *ngIf="isSecondCurrencyActive() && getSecondPrice(item.regular_price)"> {{getSecondPrice(item.regular_price)}} </span>
        </span>
      </ng-container>
    </p>
  </ng-template>

  <!--
    The outstanding-payment banner.

    Sits ABOVE the list rather than replacing the screen, and only appears while the
    live cart is empty (see showingOutstandingPanel) — a guest who declines and then
    adds a dish must get the ordinary editable cart back, cash orders included.

    Everything a failed payment used to say lived in a modal over an EMPTY cart, and
    vanished when dismissed. This keeps the items, the total and the order number on
    screen alongside the explanation.
  -->
  <div class="payment-panel" *ngIf="showingOutstandingPanel" [attr.data-phase]="panelPhase">
    <h2 class="payment-panel-title">{{ 'orderDetails.payment.awaitingTitle' | translate }}</h2>
    <p class="payment-panel-message">{{ panelMessageKey | translate:panelMessageParams }}</p>

    <!-- CARDHOLDERINFO. Spec Table 2: "ATTENTION! E-merchant must display the value to
         the cardholder." An obligation, not a nicety, and it applies to a refusal just
         as much as to an approval — the issuer's ACS sends it to explain why. Shown in
         every phase; the ACS decides whether to send one, so it is usually absent. -->
    <p class="payment-panel-cardholder" *ngIf="paymentCardholderInfo">{{ paymentCardholderInfo }}</p>

    <!-- The one phase where the guest may actually have been charged. They need the
         order number and the amount to quote, and a way to reach a human — the app
         must not tell someone to "check with the venue" having just deleted every
         detail they could check with. -->
    <p class="payment-panel-reference" *ngIf="panelPhase === 'unconfirmed'">
      {{ 'orderDetails.payment.reference' | translate:{ order: awaitingPayment?.orderId, amount: (awaitingPayment?.total | number:'1.2-2') } }}
    </p>

    <!-- Dimmed and inert while a request is in flight: the loading overlay is
         deliberately suppressed whenever this panel is up, so without this the buttons
         stay live through a poll and a second tap lands on a request already running. -->
    <div class="payment-panel-actions" [class.is-working]="isLoading || isConfirmingPayment">
      <button class="payment-panel-primary" *ngIf="canContinuePayment"
              [disabled]="isLoading || isConfirmingPayment" (click)="continuePayment()">
        {{ 'orderDetails.payment.continuePayment' | translate }}
      </button>
      <button class="payment-panel-primary" *ngIf="canPayAgain"
              [disabled]="isLoading || isConfirmingPayment" (click)="retryPayment()">
        {{ 'orderDetails.payment.retry' | translate }}
      </button>
      <button class="payment-panel-secondary" *ngIf="panelPhase === 'confirming'"
              [disabled]="isLoading || isConfirmingPayment" (click)="checkPaymentAgain()">
        {{ 'orderDetails.payment.checkAgain' | translate }}
      </button>
      <!-- The one phase where money may have moved, and the one place a route to a
           human belongs. Hidden when the venue has no number on file: a tel: link with
           nothing behind it is worse than no button. -->
      <a class="payment-panel-secondary" *ngIf="panelPhase === 'unconfirmed' && venuePhone"
         [href]="'tel:' + venuePhone">
        {{ 'orderDetails.payment.contactVenue' | translate }}
      </a>
      <button class="payment-panel-secondary"
              [disabled]="isLoading || isConfirmingPayment" (click)="startNewOrder()">
        {{ 'orderDetails.payment.startNewOrder' | translate }}
      </button>
    </div>
  </div>

  <div class="items-container">
    <div class="items-header">
      <h2>{{ 'orderDetails.items.title' | translate }}</h2>
      <!-- No "add more" onto an order that is already closed server-side. -->
      <button *ngIf="!readOnlyItems" (click)="addMoreClicked()">{{ 'orderDetails.items.addMore' | translate }}</button>
    </div>
    <!-- The edit hint, once for the whole list: every row's description is the same string, and
         referencing one node keeps it out of each heading's subtree (see the title's comment). -->
    <span id="cart-addon-edit-hint" class="sr-only">{{ 'addOns.edit' | translate }}</span>
    <!-- <div class="items-container" *ngIf="cartItems.length > 0"> -->
    <!-- One row per LINE (product + exact add-on selection), so one dish can legitimately appear
         twice. trackBy is the line key rather than the product id: the two rows share an id, and
         tracking by it lets Angular reuse one row's DOM for the other on the next emission. -->
    <div class="cart-item" [class.no-image]="!hasValidImage(item) || isImageError(item.id)"
      *ngFor="let item of displayItems; trackBy: trackByLineKey">
      <!-- Card body: iOS CustomRoundedShape10, drawn as SVG so it themes. viewBox aspect ≈ row so it doesn't distort. -->
      <!-- The card body (iOS CustomRoundedShape10), drawn in THREE slices rather than as one
           stretched path.

           It was a single <svg preserveAspectRatio="none"> covering the whole card. That stretches
           the shape's geometry with the box, and this shape's defining feature is a top edge that
           slopes down 16 units in 100 — so the slope scaled with row height. At the old fixed 100px
           row it read as styling; now that a row with add-ons is 175-270px tall it became a 28-43px
           diagonal that pushed the end of the title and the price outside the card entirely.

           Slicing it fixes the geometry where it matters and stretches only where nothing is drawn:
           the top cap keeps the slope and both upper corners at a FIXED 27px, the bottom cap keeps
           the lower corners at a fixed 10px, and only the plain middle — two vertical lines and a
           fill — absorbs the row's height. Horizontal stretch stays, as it always did; the slope is
           defined across the full width, so that is the axis it is supposed to scale on. -->
      <div class="cart-item-bg" aria-hidden="true">
        <svg class="bg-cap bg-cap-top" viewBox="0 0 338 27" preserveAspectRatio="none">
          <path class="bg-fill" d="M 0,27 L 0,10 Q 0,0 9.99,0.49 L 328.01,16.17 Q 338,16.67 338,26.67 L 338,27 Z" />
          <path class="bg-stroke" d="M 0,27 L 0,10 Q 0,0 9.99,0.49 L 328.01,16.17 Q 338,16.67 338,26.67 L 338,27"
                vector-effect="non-scaling-stroke" />
        </svg>
        <div class="bg-mid"></div>
        <svg class="bg-cap bg-cap-bottom" viewBox="0 0 338 10" preserveAspectRatio="none">
          <path class="bg-fill" d="M 0,0 L 338,0 Q 338,10 328,10 L 10,10 Q 0,10 0,0 Z" />
          <path class="bg-stroke" d="M 338,0 Q 338,10 328,10 L 10,10 Q 0,10 0,0"
                vector-effect="non-scaling-stroke" />
        </svg>
      </div>
      <!-- Omit the image tile entirely for items without a valid image (iOS parity). -->
      <div class="order-image" *ngIf="hasValidImage(item) && !isImageError(item.id)">
        <!-- Plain <img> shown at its natural ratio (object-fit: contain) in a themed rounded tile —
             same treatment as the recommended (most-ordered) cards, so images show consistently. -->
        <img [src]="getItemImageSrc(item)" alt="" (load)="onImageLoad(item.id)" (error)="onImageError(item.id)"
             [style.opacity]="isImageLoaded(item.id) ? 1 : 0" />
        <div class="image-placeholder" *ngIf="!isImageLoaded(item.id)">
          <div class="spinner"></div>
        </div>
      </div>
      <!-- Greedy: the quantity control lives inside this column now, so the column has to reach the
           card's trailing edge for the control to sit there. The title gets that width too, which is
           the point — it used to truncate mid-word against a stepper that had room to spare. -->
      <div class="item-details">
        <!-- Tap-to-edit sits on the title (and on the add-on summary below), never on the whole
             column: the stepper lives in this column now, and a column-wide gesture would swallow
             every +/-. The hint is announced only on a line that HAS add-ons — "edit add-ons" on a
             dish that offers none is worse than announcing nothing. -->
        <!-- The button semantics sit on the inner span, never on the <h3>: an ARIA role REPLACES
             an element's implicit one, so `role="button"` on the heading itself would drop every
             cart item name out of screen-reader heading navigation — a web-only regression with no
             iOS counterpart, where `.accessibilityAddTraits(.isButton)` ADDS to a plain Text.

             The hint is a DESCRIPTION, not a label. An `aria-label` here would have been correct for
             the button and wrong for the heading above it: a heading computes its name from its
             subtree, and step 2C of accname substitutes a descendant's `aria-label` for its text —
             so every add-on row's heading announced "Margherita, Edit add-ons" and the heading list
             stopped reading as a list of dishes. A description is not part of name computation, and
             the hint element lives outside the <h3> so its text is not in the subtree either. This
             is what iOS does too: `.accessibilityHint`, not a renamed label. -->
        <h3>
          <span [class.editable]="canEditLine(item)" (click)="openLineEditor(item)"
            (keydown.enter)="openLineEditor(item)" (keydown.space)="$event.preventDefault(); openLineEditor(item)"
            [attr.role]="canEditLine(item) ? 'button' : null" [attr.tabindex]="canEditLine(item) ? 0 : null"
            [attr.aria-describedby]="canEditLine(item) && hasSupplements(item) ? 'cart-addon-edit-hint' : null">
            {{getProductName(item, currentLang)}}
          </span>
        </h3>

        <ng-container *ngTemplateOutlet="itemNoteRow; context: { item: item, editable: canEditItemNote() }"></ng-container>

        <!-- The base unit price. With no add-ons this IS the card's last row, so the stepper joins
             it; with add-ons the line total below takes that job and this stays a plain price, so
             the two figures can never double-count. -->
        <div class="money-row">
          <ng-container *ngTemplateOutlet="basePriceText; context: { item: item }"></ng-container>
          <ng-container *ngIf="!hasSupplements(item)">
            <ng-container *ngIf="!readOnlyItems"><ng-container *ngTemplateOutlet="quantityStepper; context: { item: item }"></ng-container></ng-container>
          </ng-container>
        </div>

        <ng-container *ngIf="hasSupplements(item)">
          <ng-container *ngTemplateOutlet="supplementRows; context: { item: item, editable: !readOnlyItems }"></ng-container>
          <div class="money-row">
            <ng-container *ngTemplateOutlet="lineTotalText; context: { item: item }"></ng-container>
            <ng-container *ngIf="!readOnlyItems"><ng-container *ngTemplateOutlet="quantityStepper; context: { item: item }"></ng-container></ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </div>


  <!-- ── Promo code ──────────────────────────────────────────────────────
       Below the items it discounts and directly above the total it changes, so the
       guest reads what they are buying before being asked for a code, and sees the
       effect next to the number it moves.

       Hidden entirely when the venue has no promo codes (a 404 from validate) and
       when the items are read-only — an order awaiting payment is already priced. -->
  <!-- ⚠️ Not gated on the cart being non-empty, matching iOS. Cart contents oscillate while
       a removal syncs — the local edit empties the list, then the server response arrives
       before the delete settles — so a section gated on them flickers out and back. Applying
       is disabled instead, which also keeps the client off the backend guard against giving
       an item-less order a zero-gross allocation. -->
  <div class="promo-code-section" *ngIf="!readOnlyItems && promoCodeAvailable">
    <!-- A card, not a bare field: iOS `promoCodeSection` wraps the whole thing in
         `glassCardStyle(cornerRadius: 16)` with a badged header over a divider. -->
    <div class="promo-code-card" #promoCodeCard>
      <div class="promo-code-header">
        <span class="promo-code-badge" aria-hidden="true">%</span>
        <label class="promo-code-title" for="promoCodeInput">
          {{ 'orderDetails.promoCode.label' | translate }}
        </label>
      </div>

      <div class="promo-code-divider"></div>

      <div class="promo-code-body">
        <div class="promo-code-row">
          <div class="promo-code-input-wrap">
            <input
              id="promoCodeInput"
              type="text"
              class="promo-code-input"
              [placeholder]="'orderDetails.promoCode.placeholder' | translate"
              [(ngModel)]="promoCodeInput"
              (ngModelChange)="onPromoCodeInput()"
              (focus)="onPromoCodeFocus()"
              [disabled]="!!appliedPromoCode"
              autocapitalize="characters"
              autocomplete="off"
              spellcheck="false" />
            <!-- iOS uses `checkmark.circle.fill`; the bare ✓ glyph rendered in whatever
                 the font fell back to. -->
            <span class="promo-code-checkmark" *ngIf="appliedPromoCode" aria-hidden="true">
              <svg viewBox="0 0 16 16" width="16" height="16" fill="currentColor">
                <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.93 5.51-4.6 5.05a.8.8 0 0 1-1.17.02L3.9 8.32a.8.8 0 1 1 1.14-1.12l1.67 1.7 4.04-4.44a.8.8 0 1 1 1.18 1.08z"/>
              </svg>
            </span>
          </div>

          <button
            type="button"
            class="promo-code-button"
            *ngIf="!appliedPromoCode"
            [disabled]="!canApplyPromoCode || promoCodeValidating || cartItems.length === 0"
            (click)="applyPromoCode()">
            <!-- iOS swaps the label for a spinner in place, so the button shrinks while busy. -->
            <span class="promo-code-spinner" *ngIf="promoCodeValidating" aria-hidden="true"></span>
            <ng-container *ngIf="!promoCodeValidating">
              {{ 'orderDetails.promoCode.apply' | translate }}
            </ng-container>
          </button>

          <button
            type="button"
            class="promo-code-button promo-code-button-clear"
            *ngIf="appliedPromoCode"
            (click)="clearPromoCode()">
            {{ 'orderDetails.promoCode.remove' | translate }}
          </button>
        </div>

        <p class="promo-code-error" *ngIf="promoCodeErrorKey">
          {{ 'orderDetails.promoCode.errors.' + promoCodeErrorKey | translate:promoCodeErrorParams }}
        </p>
      </div>
    </div>
  </div>

  <!-- No tip picker here any more. Tips are for online payment only, and the payment
       method is chosen after Order is tapped — so the picker lives in the dine-in payment
       sheet and the delivery/pickup form (app-tip-picker), shown while Online payment is
       chosen. The Order button below still shows a tip the server has on the order. -->

  <!-- <button class="order-now" [disabled]="cartItems.length === 0 || (orderingType !== 'dine-in' && !isFormValid())" (click)="finishOrder()"> -->
  <!-- Hidden while a payment is outstanding: finishOrder() forgot the order id on the
       way to BORICA and only MenuComponent mints a new one, so this button would close
       over nothing. startNewOrder() routes back to the menu for exactly that reason. -->
  <!-- Lifted clear of the on-screen keyboard, so it never sits on top of it or on the
       promo field being typed into. 0 when the keyboard is closed. -->
  <div class="order-now-scrim" *ngIf="!readOnlyItems" aria-hidden="true"
       [style.bottom.px]="keyboardHeight"></div>
  <button class="order-now" *ngIf="!readOnlyItems"
          [style.bottom]="keyboardHeight ? 'calc(' + keyboardHeight + 'px + 20px)' : null"
          [class.order-now-busy]="(isSubmittingOrder || isCartSyncing || isSettlingCart) && cartItems.length > 0"
          [disabled]="cartItems.length === 0 || isSubmittingOrder || isCartSyncing || isSettlingCart" (click)="finishOrder()">
    <div>
      <!-- While submitting, the count is replaced by a ring in the same circle — iOS
           trims a Circle 0→1 inside the badge rather than covering the screen. -->
      <!-- The same ring while the cart is syncing: the total is still being re-priced. -->
      <span class="order-quantity">
        <span class="order-quantity-ring" *ngIf="isSubmittingOrder || isCartSyncing || isSettlingCart" aria-hidden="true"></span>
        <ng-container *ngIf="!isSubmittingOrder && !isCartSyncing && !isSettlingCart">{{cartItems.length}}</ng-container>
      </span>
      {{ (isSubmittingOrder ? 'orderDetails.orderNow.submitting' : 'orderDetails.orderNow.button') | translate }}
    </div>
    <p [class.updating]="isCartSyncing">
      <!-- The discount sits above the total it produced. The card above already names the
           code, so this line says only what it took off — `total` is already NET, so it
           explains the number below it rather than modifying it. -->
      <span class="promo-code-discount-line" *ngIf="promoCodeDiscount > 0">
        {{ 'orderDetails.promoCode.discount' | translate }}
        −{{promoCodeDiscount | number:'1.2-2'}} <span [innerHTML]="currencySymbol"></span>
      </span>
      <!-- Like the discount, it explains the total below rather than adding to it: the
           server's `total` already includes the tip. -->
      <span class="promo-code-discount-line" *ngIf="tipAmount > 0">
        {{ 'orderDetails.tip.label' | translate }}
        +{{tipAmount | number:'1.2-2'}} <span [innerHTML]="currencySymbol"></span>
      </span>
      <!-- The same for delivery, once the guest has set an address in the Order-now sheet.
           0 is a real answer here ("Free delivery"); null means no delivery on the order. -->
      <span class="promo-code-discount-line" *ngIf="deliveryFee !== null">
        <ng-container *ngIf="deliveryFee > 0; else freeDeliveryLine">
          {{ 'orderDetails.delivery.label' | translate }}
          +{{deliveryFee | number:'1.2-2'}} <span [innerHTML]="currencySymbol"></span>
        </ng-container>
        <ng-template #freeDeliveryLine>{{ 'orderDetails.delivery.free' | translate }}</ng-template>
      </span>
      <span>
        {{total | number:'1.2-2'}} <span [innerHTML]="currencySymbol"></span>
        <span class="second-price" *ngIf="isSecondCurrencyActive() && getSecondPrice(total)"> {{getSecondPrice(total)}} <span [innerHTML]="getSecondCurrencySymbol()"></span></span>
      </span>
    </p>
  </button>
</div>
<div *ngIf="featuredProducts.length > 0" class="most-ordered" @fadeInOut
     [class.promo-behind]="showPromotion">
  <div class="most-ordered-header container">
    <h2>{{ 'orderDetails.recommended.title' | translate }}</h2>
  </div>
  <div class="most-ordered-items" [@listAnimation]="featuredProducts.length">
    <app-most-ordered-item *ngFor="let product of featuredProducts" [product]="product" [comesFrom]="comesFrom"
      [mainView]="true" [currencySymbol]="currencySymbol" @scaleInOut></app-most-ordered-item>
  </div>
</div>

<!-- Dine-in: pick a payment method, then commit with the sheet's own Order button. -->
<app-payment-method-sheet
  [open]="isDineInConfirmOpen"
  [options]="getDineInPaymentOptions()"
  variant="rows"
  titleKey="orderDetails.confirmOrder.title"
  subtitleKey="orderDetails.paymentMethod.label"
  (choose)="onDineInPaymentChosen($event)"
  (selectedChange)="onDineInMethodHighlighted($event)"
  (dismiss)="cancelDineInConfirm()">
  <!-- Projected under the rows, and only while Online payment is highlighted: the server
       drops the tip from an order paid any other way. `isDineInConfirmOpen` is part of the
       condition because projected content belongs to THIS template — the sheet closing
       does not destroy it. -->
  <app-tip-picker
    *ngIf="isDineInConfirmOpen && showDineInTipPicker"
    [settings]="tipSettings"
    [selected]="selectedTip"
    [amount]="tipAmount"
    [currencySymbol]="currencySymbol"
    [error]="tipErrorKey"
    [disabled]="cartItems.length === 0"
    (choose)="selectTip($event)">
  </app-tip-picker>
</app-payment-method-sheet>

<!-- Success Modal -->
<div class="success-modal" [class.open]="isSuccessModalOpen" (click)="toggleSuccessModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- <div class="success-icon">
      <img src="../../../assets/success.svg" alt="Success">
    </div> -->
    <h2>{{ 'orderDetails.successModal.title' | translate }}</h2>
    <p>{{ 'orderDetails.successModal.subtitle' | translate }}</p>
    <!-- CARDHOLDERINFO, spec Table 2: "ATTENTION! E-merchant must display the value to
         the cardholder." Sent only when the issuer's ACS chooses to, so it is usually
         absent — but showing it when it arrives is an obligation, not a nicety. -->
    <p class="payment-cardholder-info" *ngIf="paymentCardholderInfo">{{ paymentCardholderInfo }}</p>
    <button class="view-details-button" (click)="orderHistory[0] && viewOrderDetails(orderHistory[0].id, true)">
      {{ 'orderDetails.successModal.viewDetails' | translate }}
    </button>
  </div>
</div>

<!-- Loading Overlay -->
<!-- Also covers the return from BORICA, while /payment-status is being asked what
     actually happened. The guest must not see an empty cart in the meantime. -->
<!-- Not while the outstanding-payment panel is up: a fixed, full-viewport, z-index
     1000 overlay would hide the items and the explanation behind an opaque
     spinner, which is the screen this work exists to replace. -->
<!-- Nor while the order bar is reporting the submission itself: the bar's own ring is
     the iOS treatment, and both firing at once would bury it behind the dim layer.
     The screen is still locked for the duration — see `.submitting` below. -->
<div class="loading-overlay" [class.active]="(isLoading || isConfirmingPayment) && !showingOutstandingPanel && !isSubmittingOrder">
  <div class="loader"></div>
</div>

<!-- Order Details Drawer -->
<div class="order-details-drawer" [class.open]="isOrderDetailsDrawerOpen" (click)="toggleOrderDetailsDrawer()">
  <div class="drawer-content" (click)="$event.stopPropagation()">
    <!-- iOS `navigationHeader`: a circular back button, a centred title, and a clear spacer
         the same size as the button so the title centres optically. The title keeps the order
         number rather than iOS's generic "Order details" — it is the one thing that says WHICH
         past order this is.

         The back button is the only close affordance other than tapping the backdrop, which
         was not discoverable and is not reachable at all by keyboard. -->
    <div class="drawer-header">
      <span class="drawer-grabber" aria-hidden="true"></span>
      <div class="drawer-header-row">
        <!-- Literal, like the screen's own back button above and the steppers: this file does
             not localise its aria-labels, and one localised label among them would be the odd
             one out rather than an improvement. -->
        <button class="drawer-back" (click)="toggleOrderDetailsDrawer()" aria-label="back">
          <svg class="back-icon" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M7.66602 14.25L1.41602 8L7.66602 1.75" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="drawer-header-title">
          <h2>{{ 'orderDetails.orderDrawer.order' | translate }}{{selectedOrder?.id}}</h2>
          <p *ngIf="tableName || tableId">{{ 'orderDetails.orderDrawer.table' | translate }} {{tableName || tableId}}</p>
        </div>
        <span class="drawer-header-spacer"></span>
      </div>
    </div>

    <div class="drawer-info">
      <span class="order-status order-status-drawer" *ngIf="orderStatusKey(selectedOrder) as statusKey"
            [ngClass]="orderStatusClass(selectedOrder)">
        {{ statusKey | translate }}
      </span>
      <!-- What this order says about money, when it says anything. Absent for cash and
           pay-at-the-table orders, which is the ordinary case. -->
      <div class="order-payment-summary" *ngIf="selectedOrderPaymentKey">
        {{ selectedOrderPaymentKey | translate }}
      </div>
      <div class="order-details-note" *ngIf="selectedOrder && selectedOrder.note">
        <h3>{{ 'orderDetails.orderDrawer.note.title' | translate }}</h3>
        <p>{{selectedOrder.note}}</p>
      </div>
      <!-- `OrderHistoryItem.items` is a snapshot of `CartItem[]`, so a submitted order carries its
           add-ons for free — and the order total was already computed add-on inclusive by the cart
           (it is the same `total$` this screen bound before submitting), so nothing here has to
           re-add them. Rows get the same summary as the live cart, minus the gestures. -->
      <div class="order-items" *ngIf="selectedOrder">
        <h3 class="drawer-items-title">{{ 'orderDetails.items.title' | translate }}</h3>

        <div class="cart-item" [class.no-image]="!hasValidImage(item) || isImageError(item.id)"
          *ngFor="let item of selectedOrder.items; trackBy: trackByLineKey">
          <!-- The same card body and image tile the live cart draws, rather than a second
               rendering of the same row.

               What was here before was a Figma-exported <svg> that painted the photo through a
               <pattern> with a hard-coded matrix — so it only lined up for one exact source
               resolution and otherwise left the flat fill showing — and whose <pattern>/<filter>
               ids were keyed on the PRODUCT id. trackByLineKey allows two lines of the same
               product with different add-ons, and two such rows emitted duplicate DOM ids, so
               url(#pattern0_X) resolved to the first and the second row painted the first row's
               image. It also omitted the isImageError check the live cart makes, so a dead URL
               left a large empty tile where the photo should be. -->
          <div class="cart-item-bg" aria-hidden="true">
            <svg class="bg-cap bg-cap-top" viewBox="0 0 338 27" preserveAspectRatio="none">
              <path class="bg-fill" d="M 0,27 L 0,10 Q 0,0 9.99,0.49 L 328.01,16.17 Q 338,16.67 338,26.67 L 338,27 Z" />
              <path class="bg-stroke" d="M 0,27 L 0,10 Q 0,0 9.99,0.49 L 328.01,16.17 Q 338,16.67 338,26.67 L 338,27"
                    vector-effect="non-scaling-stroke" />
            </svg>
            <div class="bg-mid"></div>
            <svg class="bg-cap bg-cap-bottom" viewBox="0 0 338 10" preserveAspectRatio="none">
              <path class="bg-fill" d="M 0,0 L 338,0 Q 338,10 328,10 L 10,10 Q 0,10 0,0 Z" />
              <path class="bg-stroke" d="M 338,0 Q 338,10 328,10 L 10,10 Q 0,10 0,0"
                    vector-effect="non-scaling-stroke" />
            </svg>
          </div>
          <div class="order-image" *ngIf="hasValidImage(item) && !isImageError(item.id)">
            <img [src]="getItemImageSrc(item)" alt="" (load)="onImageLoad(item.id)" (error)="onImageError(item.id)"
                 [style.opacity]="isImageLoaded(item.id) ? 1 : 0" />
            <div class="image-placeholder" *ngIf="!isImageLoaded(item.id)">
              <div class="spinner"></div>
            </div>
          </div>
          <!-- Same column structure as the live cart: the quantity sits on the card's last money
               row. Here it is a plain `x3` rather than a stepper — a submitted order is read-only —
               which is exactly how iOS renders this view with `isEdited: false`. -->
          <div class="item-details">
            <h3>{{getProductName(item, currentLang)}}</h3>

            <ng-container *ngTemplateOutlet="itemNoteRow; context: { item: item, editable: false }"></ng-container>

            <div class="money-row">
              <ng-container *ngTemplateOutlet="basePriceText; context: { item: item }"></ng-container>
              <span class="item-quantity" *ngIf="!hasSupplements(item)">x{{item.quantity}}</span>
            </div>

            <ng-container *ngIf="hasSupplements(item)">
              <ng-container *ngTemplateOutlet="supplementRows; context: { item: item, editable: false }"></ng-container>
              <div class="money-row">
                <ng-container *ngTemplateOutlet="lineTotalText; context: { item: item }"></ng-container>
                <span class="item-quantity">x{{item.quantity}}</span>
              </div>
            </ng-container>
          </div>
        </div>
      </div>



      <div class="order-summary" *ngIf="selectedOrder">
        <!-- The receipt rows that account for the total below. `total` is already NET, so
             the subtotal is reconstructed by adding the discount back onto it. Nothing
             renders here on an order placed without a code. -->
        <!-- The subtotal is the items: the net total, plus what the code took off, minus the
             tip and the delivery fee that the total also includes. -->
        <div class="summary-row summary-row-quiet" *ngIf="selectedOrder.discountTotal || selectedOrder.tipAmount || selectedOrder.deliveryFee != null">
          <span>{{ 'orderDetails.promoCode.subtotal' | translate }}</span>
          <span>
            {{selectedOrder.total + (selectedOrder.discountTotal || 0) - (selectedOrder.tipAmount || 0) - (selectedOrder.deliveryFee || 0) | number:'1.2-2'}} <span [innerHTML]="currencySymbol"></span>
          </span>
        </div>
        <ng-container *ngIf="selectedOrder.discountTotal">
          <div class="summary-row summary-row-quiet">
            <!-- The code names itself, so the row says which promotion was used rather
                 than the generic word "Discount". -->
            <span>{{ selectedOrder.promoCode || ('orderDetails.promoCode.discount' | translate) }}</span>
            <span class="summary-discount">
              −{{selectedOrder.discountTotal | number:'1.2-2'}} <span [innerHTML]="currencySymbol"></span>
            </span>
          </div>
        </ng-container>
        <div class="summary-row summary-row-quiet" *ngIf="selectedOrder.tipAmount">
          <span>{{ 'orderDetails.tip.label' | translate }}</span>
          <span>
            +{{selectedOrder.tipAmount | number:'1.2-2'}} <span [innerHTML]="currencySymbol"></span>
          </span>
        </div>
        <div class="summary-row summary-row-quiet" *ngIf="selectedOrder.deliveryFee != null">
          <span>{{ (selectedOrder.deliveryFee > 0 ? 'orderDetails.delivery.label' : 'orderDetails.delivery.free') | translate }}</span>
          <span *ngIf="selectedOrder.deliveryFee > 0">
            +{{selectedOrder.deliveryFee | number:'1.2-2'}} <span [innerHTML]="currencySymbol"></span>
          </span>
        </div>

        <div class="summary-row">
          <span>{{ 'orderDetails.orderDrawer.summary.total' | translate }}</span>
          <span>
            {{selectedOrder.total | number:'1.2-2'}} <span [innerHTML]="currencySymbol"></span>
            <span class="second-price" style="display: block; text-align: right;" *ngIf="isSecondCurrencyActive() && getSecondPrice(selectedOrder.total)">  {{getSecondPrice(selectedOrder.total)}} <span [innerHTML]="getSecondCurrencySymbol()"></span></span>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Before-order promotion.
     IMAGE-ONLY, BY DESIGN. A `before-order-promotion` document holds one `imageUrl`, and that is
     not changing: video, galleries and the sound and crop controls that come with them live on the
     notification promotion screen, which has the media model for them. What the two screens share
     is the composition — media to the edges, text on a scrim over it, one action on solid ground. -->
<div class="promo-scrim" *ngIf="showPromotion" @promoScrim (click)="closePromotion()"></div>

<div class="promo-sheet" *ngIf="showPromotion" @promoSheet role="dialog" aria-modal="true">
  <div class="promo-stage" [class.promo-stage-empty]="!promotionMedia">

    <ng-container *ngIf="promotionMedia">
      <div class="promo-plate" *ngIf="promotionBackdropUrl as backdrop"
           [style.background-image]="'url(' + backdrop + ')'"></div>

      <app-event-media class="promo-media" [item]="promotionMedia" [alt]="promotionTitle"
                       [fit]="promotionFit"
                       (aspectResolved)="onPromotionAspect($event)"></app-event-media>

      <div class="promo-scrim-grad" aria-hidden="true"></div>
    </ng-container>

    <div class="promo-top">
      <div class="promo-shop promo-glass" *ngIf="promotionShopName">
        <app-event-image class="promo-shop-logo" *ngIf="promotionShopLogoUrl"
                         [url]="promotionShopLogoUrl" [alt]="promotionShopName"></app-event-image>
        <span class="promo-shop-name">{{ promotionShopName }}</span>
      </div>
      <span class="promo-top-spacer"></span>
      <button type="button" class="promo-glass promo-icon-btn" (click)="closePromotion()"
              [attr.aria-label]="'promotion.close' | translate">
        <app-event-icon name="close" [size]="20"></app-event-icon>
      </button>
    </div>

    <div class="promo-text" [class.promo-text-open]="promoTextExpanded">
      <h2 class="promo-title" [appCompactPast]="2" *ngIf="promotionTitle"
          [class.promo-clamp-title]="!promoTextExpanded"
          (appOverflows)="onPromoTextOverflow($event)">{{ promotionTitle }}</h2>
      <p class="promo-body" *ngIf="promotionDescription"
         [class.promo-clamp-body]="!promoTextExpanded"
         (appOverflows)="onPromoTextOverflow($event)">{{ promotionDescription }}</p>

      <button type="button" class="promo-more"
              *ngIf="promoTextTruncated || promoTextExpanded"
              (click)="togglePromoText()">
        {{ (promoTextExpanded ? 'promotion.close' : 'events.readMore') | translate }}
      </button>
    </div>
  </div>

  <div class="promo-footer">
    <button type="button" class="promo-cta" (click)="addPromotionProductToOrder()"
            [disabled]="promotionLoading">
      <ng-container *ngIf="!promotionLoading; else loadingTpl">{{ 'orderDetails.orderNow.button' | translate }}</ng-container>
      <ng-template #loadingTpl>
        <div class="spinner"></div>
      </ng-template>
    </button>
  </div>
</div>

<!-- Ordering Unavailable Modal -->
<div class="ordering-unavailable-modal" [class.open]="isOrderingUnavailableModalOpen"
  (click)="closeOrderingUnavailableModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div>
      <h2>{{ orderingUnavailableCopy.title | translate }}</h2>
      <p>{{ orderingUnavailableCopy.message | translate }}</p>
    </div>
    <button class="got-it-button" (click)="closeOrderingUnavailableModal()">
      {{ 'orderDetails.orderingUnavailable.gotIt' | translate }}
    </button>
  </div>
</div>



<!-- Delivery/Pickup Form Modal -->
<!-- Unavailable product alert (single product) -->
<div class="modal-backdrop" *ngIf="showUnavailableAlert" (click)="showUnavailableAlert = false"></div>
<div class="unavailable-alert-modal" *ngIf="showUnavailableAlert">
  <h3>{{ 'menu.availability.notAvailable' | translate }}</h3>
  <p>{{ unavailableAlertMessage }}</p>
  <button class="alert-ok-button" (click)="showUnavailableAlert = false">OK</button>
</div>

<!-- Unavailable items confirmation (order submit) -->
<div class="modal-backdrop" *ngIf="showUnavailableItemsConfirm" (click)="cancelUnavailableRemoval()"></div>
<div class="unavailable-alert-modal" *ngIf="showUnavailableItemsConfirm">
  <h3>{{ 'orderDetails.unavailableItems.title' | translate }}</h3>
  <p>{{ 'orderDetails.unavailableItems.message' | translate:{ items: unavailableItemNames.join(', ') } }}</p>
  <div class="alert-actions">
    <button class="alert-destructive-button" (click)="removeUnavailableItemsAndSubmit()">
      {{ 'orderDetails.unavailableItems.removeAndProceed' | translate }}
    </button>
    <button class="alert-cancel-button" (click)="cancelUnavailableRemoval()">
      {{ 'orderDetails.cancel' | translate }}
    </button>
  </div>
</div>

<!-- The applied code died before the order went through, so the total went UP.

     The server REFUSED to place the order over it, which is what makes this a decision
     rather than a notice: nothing reached the venue and no card was charged, so the guest
     can accept the new price or go back to the cart. The dismissal path is Cancel, not OK —
     closing the dialog must not be read as agreeing to pay more. -->
<div class="modal-backdrop" *ngIf="showPromoCodeRefusedConfirm" (click)="cancelOrderAtCorrectedTotal()"></div>
<div class="unavailable-alert-modal" *ngIf="showPromoCodeRefusedConfirm">
  <!-- A lowered discount is not a dead code — the code still applies — so it gets its own
       title rather than "no longer valid". -->
  <h3>{{ (promoCodeRefusedKey === 'changed' ? 'orderDetails.promoCode.refused.changedTitle' : 'orderDetails.promoCode.refused.title') | translate }}</h3>
  <p>{{ 'orderDetails.promoCode.errors.' + promoCodeRefusedKey | translate:promoCodeRefusedParams }}</p>
  <p>{{ 'orderDetails.promoCode.refused.newTotal' | translate:{ total: (promoCodeRefusedTotal | number:'1.2-2') } }}</p>
  <!-- Confirm/cancel ONLY when a submit is waiting on the answer. Noticed mid-edit there
       is nothing to agree to, and offering "Order anyway" would place an order the guest
       never asked for. -->
  <div class="alert-actions" *ngIf="promoCodeRefusedBlockedSubmit; else refusedNotice">
    <button class="alert-destructive-button" (click)="confirmOrderAtCorrectedTotal()">
      {{ 'orderDetails.promoCode.refused.orderAnyway' | translate }}
    </button>
    <button class="alert-cancel-button" (click)="cancelOrderAtCorrectedTotal()">
      {{ 'orderDetails.cancel' | translate }}
    </button>
  </div>
  <ng-template #refusedNotice>
    <button class="alert-ok-button" (click)="acknowledgePromoCodeRefused()">OK</button>
  </ng-template>
</div>

<app-delivery-form
  [isOpen]="isDeliveryFormOpen"
  [clientData]="clientData"
  [pickupLocations]="pickupLocations"
  [deliveryData]="deliveryData"
  [isAddressReadOnly]="isAddressReadOnly"
  [submitRefusal]="deliverySubmitRefusal"
  (formSubmit)="onDeliveryFormSubmit($event)"
  (formCancel)="onDeliveryFormCancel()">
</app-delivery-form>

<!-- Opened from Order before the order goes out; either answer continues it (askForOrderUpdates). -->
<app-push-prompt
  [isOpen]="isOrderPushPromptOpen"
  source="order"
  (accepted)="onOrderPushPromptClosed()"
  (dismissed)="onOrderPushPromptClosed()">
</app-push-prompt>
